import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { KrakenLogo } from "@/components/PublicLayout";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "", role: "parent" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr(""); setLoading(true);
    try { await register(form); nav("/portal"); }
    catch (e) { setErr(e.message); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 text-white" data-testid="register-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8"><KrakenLogo /></Link>
        <form onSubmit={submit} className="kr-card rounded-2xl p-8 space-y-4" data-testid="register-form">
          <div className="text-center">
            <div className="eyebrow mb-2">New Account</div>
            <h1 className="font-display text-3xl uppercase">Join The Kraken</h1>
          </div>
          <input required placeholder="Full Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" data-testid="register-name" />
          <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" data-testid="register-email" />
          <input placeholder="Phone (optional)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" />
          <input required type="password" placeholder="Password (min 6)" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3" data-testid="register-password" />
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full bg-[#050A15] border border-white/10 rounded-md p-3">
            <option value="parent">Parent</option>
            <option value="player">Player</option>
          </select>
          {err && <div className="text-red-400 text-sm" data-testid="register-error">{err}</div>}
          <button disabled={loading} className="btn-primary w-full justify-center" data-testid="register-submit">{loading ? "Creating..." : "Create Account"}</button>
          <div className="text-center text-sm text-slate-400">
            Already have an account? <Link to="/login" className="text-[#00E5FF]">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
